export default (state: any): string | null => {
  return state.selfcare?.queryParams?.numContract || null;
};
